module.exports = __webpack_public_path__ + "img/informacion.957fa25b.svg";